export default "__VITE_ASSET__e9htWj5Q__"